import {watchLastTransferForBundleTqo} from "../rpc/webrpc-client.gen.ts";
import {useMountedTruck} from "./mountedTruck.ts";
import {useRefreshableInfallibleQuery} from "../util/tqrefresh.tsx";
import {InfallibleUseResult, pendingUseResult, successUseResult} from "../util/hookutil.tsx";
import {useMothership} from "../tq/tqx.tsx";

export function useIsMyBundle(args ?: { bundleId: string }): InfallibleUseResult<boolean> {
    const mama = useMothership();
    const xferTqrv
        = useRefreshableInfallibleQuery(watchLastTransferForBundleTqo(mama, args));
    const mountedTruckTqrv = useMountedTruck();

    if (xferTqrv.isPending || mountedTruckTqrv.isPending) {
        return pendingUseResult;
    }

    const mountedTruck = mountedTruckTqrv.data;
    const xfer = xferTqrv.data;
    return successUseResult(!!mountedTruck && mountedTruck.id === xfer?.truck.id);
}


